// Design tokens from Figma
const tokens = {
  colors: {
    brand: {
      50: "#e2f5f6",
      100: "#c6ebee",
      350: "#38b9c4",
      500: "#0093a0",
      550: "#00818c",
      700: "#004950",
      800: "#002428",
    },
    neutral: {
      0: "#ffffff",
      50: "#f2f2f2",
      100: "#dae2e5",
      800: "#333738",
    },
    transparent: {
      primary95: "#002428f2",
      primary90: "#002428e5",
    },
    background: {
      primary: "#FFFFFF",
    },
  },
  spacing: {
    xs: "4px",
    s: "8px",
    m: "12px",
    l: "16px",
    xl: "24px",
    "2xl": "32px",
    "3xl": "40px",
    "4xl": "48px",
  },
  radius: {
    m: "12px",
    l: "16px",
    pill: "999px",
    circle: "50px",
  },
};

export default tokens;
